import React, {useEffect, useState} from 'react';
import {
    cuadroRequerimientosEjecutarEtapaAPI,
    cuadroRequerimientosGetMonitorCampanaAPI, cuadroRequerimientosIniciarEtapaAPI,
    cuadroRequerimientosReprocesarEtapaAPI,
} from "../../../../consumers/backendApisUrls";
import ModalForm from "../../../../components/modalComponents/ModalForm";
import PropTypes from "prop-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useGetRequest} from "../../../../hooks/useGetRequest/useGetRequest";
import {usePostRequest} from "../../../../hooks/usePostRequest/usePostRequest";
import {useDescargarArchivoDeS3} from "../../../../hooks/useGenerarDescargarEliminarArchivo/useDescargarArchivoDeS3";
import {mostrarMensajeDeErrorConToast, responseCode200} from "../../../../consumers/httpRequiestsUtils";
import {toast} from "react-toastify";
import MensajeConfirmacionEliminarCasoModal
    from "../../cuadroRequerimientosGrafico/menus/comentarios/modales/MensajeConfirmacionEliminarCasoModal";
import MensajeConfirmacionIniciarEtapaModal
    from "../../cuadroRequerimientosGrafico/menus/comentarios/modales/MensajeConfirmacionIniciarEtapaModal";

const acciones = {
    'etapas': {
        'iniciar': {
            'textButton': "Iniciar", api() {
                return cuadroRequerimientosIniciarEtapaAPI
            }
        },
        'finalizar': {
            'textButton': "Finalizar", api() {
                return cuadroRequerimientosEjecutarEtapaAPI
            }
        },
        'reprocesar': {
            'textButton': "Reprocesar", api() {
                return cuadroRequerimientosReprocesarEtapaAPI
            }
        }
    }
}

const MonitorCampana = ({toggleModal, manageSearch, idCampana,getAllCampanas, setModalConfirmarEnabled }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const [etapas, setEtapas] = useState([]);
    const [isLoadingEtapas, setIsLoadingEtapas] = useState({});
    const [executeGetRequest] = useGetRequest();
    const [executePostRequest] = usePostRequest();
    const [descargarArchivoDeS3] = useDescargarArchivoDeS3();

    const callApi = async function (api, id) {
        const response = await executePostRequest(api, {});
        await manageApiResponseCustom(response, getEtapas);
        if (response) setIsLoadingEtapas({...isLoadingEtapas, [id]: false});
    };

    const getEtapas = async function () {
        const response = await executeGetRequest(cuadroRequerimientosGetMonitorCampanaAPI(idCampana));
        if (responseCode200(response)) {
            setEtapas(response?.data);
            setIsLoadingEtapas(Object.fromEntries(response.data?.Etapas.map(etapa => [etapa.IdMonitorCampana, false])))

        } else {
            mostrarMensajeDeErrorConToast(response);
        }
    }

    const manageApiResponseCustom = async (response, callbackSuccess) => {
        if (responseCode200(response)) {
            toast.success(response?.data?.Message);
            callbackSuccess(response);
        } else {
            mostrarMensajeDeErrorConToast(response);
            if (response.response.status === 400) {
                callbackSuccess(response)
            }
        }
    };

    const descargarLog = async function (originalFileName, filePath) {
        await descargarArchivoDeS3(originalFileName, filePath);
    }

    const init = async function () {
        await getEtapas();
    };

    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);


    const onClicIniciarTerminarEtapa = async (etapa) => {
        //e.preventDefault();
        setIsLoadingEtapas({...isLoadingEtapas, [etapa.IdMonitorCampana]: true});
        let api = acciones['etapas'][etapa?.Code].api();
        await callApi(api(etapa?.IdMonitorCampana), etapa?.IdMonitorCampana);
    }

    return (
        <ModalForm
            titulo="Monitor Campaña"
            width="1200px"
            showModal={async () => {toggleModal(); await getAllCampanas(); await manageSearch();}}
            isSubmitting={isSubmitting}
            saveButtonDisabled={isUploading || isSubmitting}
            hasSaveButton={false}
            >


                <div>
                    <p><strong>Campaña:</strong> {etapas?.Campana}</p>
                    <table className="table table-hover" style={{backgroundColor: '#fff'}}>
                        <thead>
                        <tr className="d-flex">
                            <th className="p-0 col-2">Nombre</th>
                            <th className="p-0 col-2">Inicio</th>
                            <th className="p-0 col-2">Fin</th>
                            <th className="p-0 col-2">Estado Proceso</th>
                            <th className="p-0 col-2">Resultado</th>
                            <th className="p-0 col-2">Acción</th>
                        </tr>
                        </thead>
                        <tbody>
                        {etapas?.Etapas && etapas?.Etapas.map((etapa, index) => {
                            return (
                                <tr key={index} className="d-flex">
                                    <td className="p-0 col-2">{etapa?.Nombre}</td>
                                    <td className="p-0 col-2">{etapa?.FechaInicio}</td>
                                    <td className="p-0 col-2">{etapa?.FechaFin}</td>
                                    <td className="p-0 col-2">{etapa?.EstadoProceso}</td>
                                    <td className="p-0 col-2">{isLoadingEtapas[etapa.IdMonitorCampana]? "Procesando": etapa?.EstadoResultado}
                                        {etapa?.FileViewModel &&
                                            <FontAwesomeIcon icon='file-alt' transform="left-1" className="hand-pointer blue-standard-color ml-2" onClick={() => descargarLog(etapa?.FileViewModel?.OriginalFileName, etapa?.FileViewModel?.Path)} title={"Descargar log"}/>
                                        }
                                    </td>
                                    <td className="p-0 col-2">
                                        {etapa?.Code && etapa?.MostrarBoton === true && !isLoadingEtapas[etapa.IdMonitorCampana] &&
                                            <button className="btn btn-primary generic-button-ficha pt-0 pb-0" onClick={async (e)=>
                                            {
                                                if (e) e.preventDefault()

                                                if (etapa.MostrarBotonConfirmarOnClickButton)
                                                    setModalConfirmarEnabled({
                                                        isEnable: true,
                                                        component: MensajeConfirmacionIniciarEtapaModal,
                                                        data: {
                                                            nombreCampana: etapas?.Campana,
                                                            onClickButton: onClicIniciarTerminarEtapa,
                                                            etapa: etapa
                                                        },
                                                    })
                                                else
                                                 await onClicIniciarTerminarEtapa(etapa);


                                            }}>
                                                {acciones['etapas'][etapa?.Code]['textButton']}
                                            </button>
                                        }
                                    </td>

                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                </div>

        </ModalForm>
    );
}

MonitorCampana.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}


export default MonitorCampana;